import axios from "axios";

export default {
	listStudents(ctx) {
		return axios.get("/v3/students", { params: ctx });
	},

	listStudentsWithClasses(ctx, districtID) {
		if (districtID != undefined) {
			ctx.district_id = districtID;
		}
		return axios.get("/v3/students+classes", { params: ctx });
	},

	listStudentsFromClass(classID) {
		return axios.get(`/v3/class/${classID}/students`);
	},

	getStudent(id) {
		return axios.get(`/v3/student/${id}`);
	},

	getStudentMatches(students, districtID) {
		console.log("Request matched", students);
		return axios.post(`v3/match/students/${districtID}`, students);
	},

	saveStudent(student) {
		return axios.post("/v3/student", student);
	},

	deleteStudent(id) {
		return axios.delete(`/v3/student/${id}`);
	},

	removeStudentFromClass(studentID, classID) {
		return axios.delete(`/v3/class/${classID}/student/${studentID}`);
	}
};



// WEBPACK FOOTER //
// ./src/services/StudentService.js